import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
} from '@mui/material';
import { CalendarToday, Phone, WhatsApp } from '@mui/icons-material';
import Logo from './Logo';

const Header = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: 'white', boxShadow: 2 }}>
      <Container maxWidth="lg">
        <Toolbar>
          <Logo />
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              color: 'primary.main',
              fontWeight: 'bold',
              ml: 2,
            }}
          >
            {/* SlotSnap */}
          </Typography>
          
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
            <Button
              color="primary"
              onClick={() => scrollToSection('about')}
              sx={{ textTransform: 'none' ,fontSize:'18px'}}
            >
              About
            </Button>
            <Button
              color="primary"
              onClick={() => scrollToSection('services')}
              sx={{ textTransform: 'none',fontSize:'18px' }}
            >
              Services
            </Button>
            <Button
              color="primary"
              onClick={() => scrollToSection('contact')}
              sx={{ textTransform: 'none',fontSize:'18px' }}
            >
              Contact
            </Button>
             <Button
              color="primary"
              onClick={() => scrollToSection('howItHelps')}
              sx={{ textTransform: 'none',fontSize:'18px' }}
            >
             Help
            </Button>
          </Box>

          <Box sx={{ display: 'flex', gap: 1, ml: 2 }}>
            <Button
              variant="contained"
              startIcon={<CalendarToday />}
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': { backgroundColor: 'primary.dark' },
                textTransform: 'none',
                borderRadius: 2,
                fontSize:"20px"
              }}
            >
              Book Now
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;

